import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class, _AbLoginHistoryDialog;
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbLabel } from "abreact/incubator/ui/component/AbLabel";
import { BaseRCmp } from "abreact/incubator/ui/component/BaseRCmp";
import { DataGrid } from "abreact/incubator/ui/datagrid/DataGrid";
import { DataGridSelectionMachine, SelectionMode } from "abreact/incubator/ui/datagrid/DataGridSelectionMachine";
import { LoginHistoryColumns } from "abreact/incubator/ui/login/LoginHistoryMachine";
import { AbHBox } from "abreact/layout/AbHBox";
import { AbVBox } from "abreact/layout/AbVBox";
import { AbButton } from "abreact/misc/AbButton";
import { AbCopyButton } from "abreact/misc/AbCopyButton";
import { AbIcon } from "abreact/misc/AbIcon";
import { AbDialog } from "abreact/popup/AbDialog";
import { AbBusyIndicator } from "abreact/progress/AbBusyIndicator";
import { AbDialogButtonBar } from "absdk/commons/ui/popup/AbDialogButtonBar";
import { action } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AbAutoSizer } from "absdk/commons/ui/layout/AbAutoSizer";
export let AbLoginHistoryDialog = observer(_class = (_AbLoginHistoryDialog = class AbLoginHistoryDialog extends BaseRCmp {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "selector", new DataGridSelectionMachine());
    _defineProperty(this, "dataGrid", null);
    _defineProperty(this, "initialized", false);
    _defineProperty(this, "captureDataGrid", d => {
      if (d) {
        this.dataGrid = d;
      }
    });
    _defineProperty(this, "selectCurrentSession", () => {
      if (this.props.machine.currentSessionIndex !== null && this.dataGrid) {
        this.selector.selectRow(this.props.machine.currentSessionIndex, false);
        this.dataGrid.scrollToCell({
          rowId: this.props.machine.currentSessionIndex
        });
      }
    });
    _defineProperty(this, "renderCell", dataProps => {
      const sessionInfo = this.props.machine.loginSessionInfos[dataProps.rowIndex];
      let indicator = null;
      let className = "ab-history-grid-content ";
      if (this.props.machine.isSessionConcurrent(dataProps.rowIndex)) {
        className += "ab-concurrent-selected";
        indicator = /*#__PURE__*/React.createElement(AbIcon, {
          className: className,
          image: AbLoginHistoryDialog.CONCURRENT_SELECTED
        });
      }
      const label = s => /*#__PURE__*/React.createElement(AbLabel, {
        label: this.props.machine.isSessionActive(dataProps.rowIndex) ? /*#__PURE__*/React.createElement("b", null, s) : s
      });
      let n = null;
      switch (dataProps.columnIndex) {
        case LoginHistoryColumns.LOGIN:
          n = label(this.props.machine.getStartTimeText(sessionInfo));
          break;
        case LoginHistoryColumns.LOGOUT:
          n = label(this.props.machine.getEndTimeText(sessionInfo));
          break;
        case LoginHistoryColumns.DURATION:
          n = label(this.props.machine.getDurationText(sessionInfo));
          break;
        case LoginHistoryColumns.LOCATION:
          n = label(this.props.machine.getLocationText(sessionInfo));
          break;
        case LoginHistoryColumns.CONCURRENT:
          n = indicator;
          break;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, n);
    });
    _defineProperty(this, "onSelectionChanged", action(s => {
      const selected = s.getSelectedItems();
      this.props.machine.selectedIndex = selected.length === 0 ? null : selected[0].rowId;
    }));
  }
  render() {
    return /*#__PURE__*/React.createElement(AbDialog, {
      title: AbReactResources.loginHistory_dialog_title(),
      icon: "absdk:version-history",
      className: "ab-login-history-dialog",
      buttonBar: /*#__PURE__*/React.createElement(AbDialogButtonBar, {
        okButton: true
      }, /*#__PURE__*/React.createElement(AbCopyButton, {
        copyText: async () => this.props.machine.getGridSessionsAsTabbedString(),
        showLabel: true
      }))
    }, this.props.machine.loaded === null && /*#__PURE__*/React.createElement(AbBusyIndicator, null), this.props.machine.loaded === false && /*#__PURE__*/React.createElement(AbLabel, {
      label: AbReactResources.loginHistory_dialog_historyNotFound(),
      icon: "absdk:error"
    }), this.props.machine.loaded && /*#__PURE__*/React.createElement(AbVBox, null, /*#__PURE__*/React.createElement(AbLabel, {
      label: /*#__PURE__*/React.createElement(React.Fragment, null, "(", /*#__PURE__*/React.createElement(AbIcon, {
        image: AbLoginHistoryDialog.CONCURRENT_SELECTED
      }), ") " + AbReactResources.loginHistory_dialog_legend_concurrent())
    }), /*#__PURE__*/React.createElement(AbHBox, null, /*#__PURE__*/React.createElement(AbLabel, {
      label: /*#__PURE__*/React.createElement(React.Fragment, null, AbReactResources.loginHistory_dialog_legend_current_prefix(), /*#__PURE__*/React.createElement("b", null, AbReactResources.loginHistory_dialog_legend_current_bold()), AbReactResources.loginHistory_dialog_legend_current_suffix())
    }), /*#__PURE__*/React.createElement(AbButton, {
      label: AbReactResources.loginHistory_dialog_button_selectCurrent(),
      disabled: this.props.machine.currentSessionIndex === null,
      onClick: this.selectCurrentSession
    })), /*#__PURE__*/React.createElement("div", {
      className: "ab-login-history-content-panel"
    }, /*#__PURE__*/React.createElement(AbAutoSizer, {
      renderer: (width, height) => /*#__PURE__*/React.createElement("div", {
        className: "ab-login-history-spacer-panel",
        style: {
          width: width + "px",
          height: height + "px"
        }
      }, /*#__PURE__*/React.createElement(DataGrid, {
        height: height,
        width: Math.min(772, width),
        showColumnHeaders: true,
        showRowHeaderColumn: false,
        columns: this.props.machine.columns,
        rowCount: this.props.machine.loginSessionInfos.length,
        selectionMode: SelectionMode.SingleRow,
        cellRenderer: this.renderCell,
        onSelectionChange: this.onSelectionChanged,
        selectionMachine: this.selector,
        dataFreshness: this.props.machine.selectedIndex,
        ref: this.captureDataGrid
      }))
    }))));
  }
  componentDidUpdate() {
    if (!this.initialized && this.props.machine.loaded && this.dataGrid) {
      this.selectCurrentSession();
      this.initialized = true;
    }
  }
}, _defineProperty(_AbLoginHistoryDialog, "CONCURRENT_SELECTED", "absdk:warning"), _AbLoginHistoryDialog)) || _class;
//# sourceMappingURL=AbLoginHistoryDialog.js.map
